module.exports = __webpack_public_path__ + "img/gxa.d545fd51.svg";